<template>
  <div id="carbon" class="header-padding bg-light-grey">
    
    <section role="banner" id="banner" class="bg-grey">
      <transition name="fade">
        <div v-show="bannerImage.desktop" class="banner-image ff-mobile-hide" :style="'background-image: url(' + bannerImage.desktop + ');'"></div>
      </transition>
      <transition name="fade">
        <div v-show="bannerImage.mobile" class="banner-image ff-desktop-hide" :style="'background-image: url(' + bannerImage.mobile + ');'"></div>
      </transition>
      
      <div class="banner-content ff ff-ttb ff-align-center ff-mobile-hide" :class="bannerAlignment">
        <h1 
          class="banner-title ff-lg-6 ff-xl-5" 
          :class="bannerColor"
          style="margin-bottom:0; margin-top:0;"
        >{{ pageName }}</h1>
        <div v-if="bannerText" v-html="bannerText" class="banner-text ff-lg-6 ff-xl-5" :class="bannerColor"></div>
      </div>
      
      <div class="banner-content-mobile bg-light-grey ff-desktop-hide ff-text-center horizontal-padding section-padding">
        <h1 
          class="banner-title ff-lg-6 ff-xl-5" 
          style="margin-bottom:0; margin-top:0;"
        >{{ pageName }}</h1>
        <div v-if="bannerText" v-html="bannerText" class="banner-text"></div>
      </div>
    </section>
    
    <v-row v-for="(row, r) in rows"
      v-bind:content="row"
      v-bind:index="r"
      v-bind:key="'section-' + r"
    ></v-row>
  
  </div>
</template>

<script>
import Rows from '@/components/Rows.vue'

// @ is an alias to /src
export default {
  name: "carbon",
  components: {
    'v-row': Rows
  },
  data() {
    return {
      banner: {
        size: {
          desktop: '',
          mobile: ''
        }
      },
      pageContent: null,
      loading: false
    }
  },
  computed: {
    apiURL() {
      return this.$store.state.apiURL;
    },
    rows() {
      var rows = [];
      
      if(this.pageContent) {
        rows = this.pageContent.content.rows;
      }
      
      return rows;
    },
    pageName() {
      var pageName = '';
      
      if(this.pageContent) {
        pageName = this.pageContent.name;
      }
      
      return pageName;
    },
    screenSize(){
      var screenSize = this.$store.getters.screenSize;
      return screenSize;
    },
    bannerColor(){
      var bannerColor = 'white';
      
      if(this.pageContent) {
        bannerColor = this.pageContent.banner.images[0].text_color;
      }
      
      return bannerColor;
    },
    bannerAlignment(){
      var bannerAlignment = 'ff-center';
      
      if(this.pageContent) {
        var alignment = this.pageContent.banner.images[0].text_alignment;
        
        switch (alignment) {
          case 'left':
            bannerAlignment = 'ff-text-left ff-valign-top ff-content-top';
            break;
            
          case 'center':
            bannerAlignment = 'ff-center';
            break;
            
          case 'right':
            bannerAlignment = 'ff-text-right ff-valign-bottom ff-content-bottom';
            break;
            
          default:
            bannerAlignment = 'ff-center';
        }
      }
      
      return bannerAlignment;
    },
    bannerText(){
      var bannerText = false;
      
      if(this.pageContent) {
        bannerText = this.pageContent.banner.images[0].text;
      }
      
      return bannerText;
    },
    bannerImage(){
      var bannerImage = {
        desktop: this.banner.size.desktop,
        mobile: this.banner.size.mobile
      };
      
      return bannerImage;
    },
    meta() {
      var meta = {
        title: this.pageName,
        url: "https://www.csbplab.com.au/carbon",
        desc: "",
        image: ""
      }
      
      return meta;
    }
  },
  beforeMount() {
    
    // Check if we have pre-loaded the data server-side
    if(window.__INITIAL_STATE__) {
      var init_state = JSON.parse(window.__INITIAL_STATE__);
      
      if('carbon' in init_state.data) {
        this.pageContent = init_state.data.ourlab;
        
        // Preload and set banner images
        var vm = this;
        var bannerImages = this.pageContent.banner.images[0].sizes;
        
        this.preloadImages([
          bannerImages.desktop,
          bannerImages.mobile
        ]).then(function(imgs) {
          
          vm.banner.size.desktop = imgs[0];
          vm.banner.size.mobile = imgs[1];
        
        // eslint-disable-next-line
        }, function(errImg) {
          // eslint-disable-next-line
          console.log('There was an error loading the images.');
        });
        
      }
      
    }
    
    // If not, start loading the data client-side
    if(!this.pageContent) {
      this.loadContent();
    }
    
  },
  mounted() {
    
  },
  methods: {
     async loadContent() {
      // Start loading
      this.loading = true;
      
      // Request data from API
      await this.$axios.get(this.apiURL+'carbon').then((response) => {
        this.pageContent = response.data.page;
      // eslint-disable-next-line
      }, (error)  =>  {
        alert("There was an error loading the content for this page. Please reload page to try again.");
      });
      
      // Finish loading
      this.loading = false;
      
      // Preload and set banner images
      var vm = this;
      var bannerImages = this.pageContent.banner.images[0].sizes;
      
      this.preloadImages([
        bannerImages.desktop,
        bannerImages.mobile
      ]).then(function(imgs) {
        
        vm.banner.size.desktop = imgs[0];
        vm.banner.size.mobile = imgs[1];
      
      // eslint-disable-next-line
      }, function(errImg) {
        // eslint-disable-next-line
        console.log('There was an error loading the images.');
      });
      
    },
    preloadImages(srcs) {
      function loadImage(src) {
        
        return new Promise(function(resolve, reject) {
          var img = new Image();
          img.onload = function() {
            resolve(src);
          };
          img.onerror = img.onabort = function() {
            reject(src);
          };
          img.src = src;
        });
        
      }
      
      var promises = [];
      for (var i = 0; i < srcs.length; i++) {
        promises.push(loadImage(srcs[i]));
      }
      
      return Promise.all(promises);
    }
  },
  metaInfo () {
    return {
      title: this.meta.title,
      link: [
        {
          rel: "canonical",
          href: this.meta.url
        }
      ],
      meta: [
        {
          name: "description",
          content: this.meta.desc
        },
        {
          property: "og:title",
          content: this.meta.title + " | CSBP Lab"
        },
        {
          property: "og:url",
          content: this.meta.url
        },
        {
          property: "og:image",
          content: this.meta.image
        },
        {
          property: "og:description",
          content: this.meta.desc
        },
        {
          property: "twitter:title",
          content: this.meta.title + " | CSBP Lab"
        },
        {
          property: "twitter:site",
          content: this.meta.url
        },
        {
          property: "twitter:image.src",
          content: this.meta.image
        },
        {
          property: "twitter:description",
          content: this.meta.desc
        }
      ]
    }
  }
};
</script>